import { Controller } from '@hotwired/stimulus'
import QRCodeStyling from 'qr-code-styling'

export default class extends Controller {
  static values = { data: String }

  connect() {
    this.qrcode = new QRCodeStyling(this.options)
    this.qrcode.append(this.element)
  }

  downloadQRCode() {
    this.qrcode.download({
      name: 'qrcode',
      extension: 'svg',
    })
  }

  get options() {
    return {
      width: this.element.clientWidth,
      height: this.element.clientWidth,
      type: 'svg',
      data: this.dataValue,
      image:
        'https://bemp-public.s3.us-east-1.amazonaws.com/id/logo_vertical_black.png',
      dotsOptions: {
        color: '#000000',
        type: 'extra-rounded',
      },
      imageOptions: {
        crossOrigin: 'anonymous',
      },
      backgroundOptions: {
        color: '#ffffff',
      },
    }
  }
}
